import styled from 'styled-components'

const StFieldContainer = styled.div<{ noMargin?: boolean }>`
  width: 100%;
  ${({ theme, noMargin }) => `
    margin-bottom: ${noMargin ? '0px' : theme.UI.SpacingPx.Space6};

    & > label {
      margin-bottom: ${noMargin ? '0px' : theme.UI.SpacingPx.Space2};
    }
  `}
`

const StInputContainer = styled.label``

const StRangeInput = styled.input<{ trackPercentageValue: number }>`
  width: 100%;
  -webkit-appearance: none;

  ::-webkit-slider-runnable-track {
    margin: 0 4px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.Colors.Neutrals.Darkest} 0%,
      ${({ theme }) => theme.Colors.Neutrals.Darkest}
        ${({ trackPercentageValue }) => trackPercentageValue}%,
      ${({ theme }) => theme.Colors.Neutrals.Light}
        ${({ trackPercentageValue }) => trackPercentageValue}%,
      ${({ theme }) => theme.Colors.Neutrals.Light} 100%
    );

    height: 6px;
    border-radius: 6px;
    -webkit-appearance: none;
  }

  ::-webkit-slider-thumb {
    height: ${({ theme }) => theme.UI.SpacingPx.Space6};
    width: ${({ theme }) => theme.UI.SpacingPx.Space6};
    border: 2px solid ${({ theme }) => theme.Colors.Neutrals.Darker};
    background-color: ${({ theme }) => theme.Colors.Background.White};
    border-radius: 100%;
    cursor: pointer;
    /* Half the thumb height + half the track height to center the thumb */
    margin-top: calc(-${({ theme }) => theme.UI.SpacingPx.Space3} + 3px);
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
    -webkit-appearance: none;
  }
`

const StDataList = styled.datalist`
  ${({ theme }) => theme.Typography.BodySmallRegular}
  color: ${({ theme }) => theme.Colors.Neutrals.Dark};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space3};
  padding-left: calc(${({ theme }) => theme.UI.SpacingPx.Space3} + 2px);
  padding-right: calc(${({ theme }) => theme.UI.SpacingPx.Space3} - 2px);
`

const StBottomLabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.UI.SpacingPx.Space6};
`

export { StBottomLabelsContainer, StDataList, StFieldContainer, StInputContainer, StRangeInput }
